import { premiumMarketMoversIndex } from '~/apps/product-plus/search-domain/indexes';
import { buildPremiumMarketMoversQuery } from '~/apps/product-plus/search-domain/pipelines/premium-market-movers/build-query';
import {
  getPremiumMarketMoversBaseFilters,
  getPremiumMarketMoversFacetAttributes,
  getPremiumMarketMoversSearchSettings,
  getPremiumMarketMoversSorting,
} from '~/apps/product-plus/search-domain/pipelines/premium-market-movers/query-config';
import { type PremiumMarketMoversSearchResponseBody } from '~/apps/product-plus/search-domain/pipelines/premium-market-movers/response-factory';
import { transformPremiumMarketMoversResponse } from '~/apps/product-plus/search-domain/pipelines/premium-market-movers/transform-response';
import { type SearchPipelineDefinition, type SearchUiState } from '~/apps/product-plus/search-domain/types';

const resolvePremiumMarketMoversSorting = () => getPremiumMarketMoversSorting();

export const premiumMarketMoversPipelineDefinition: SearchPipelineDefinition<
  SearchUiState,
  PremiumMarketMoversSearchResponseBody
> = {
  buildSearchRequest: buildPremiumMarketMoversQuery,
  facetAttributes: context => getPremiumMarketMoversFacetAttributes(context),
  getBaseFilters: () => getPremiumMarketMoversBaseFilters(),
  getSearchUiConfig: context => ({
    searchAttributes: getPremiumMarketMoversSearchSettings(context).search ?? [],
    sorting: resolvePremiumMarketMoversSorting,
  }),
  getSorting: resolvePremiumMarketMoversSorting,
  id: premiumMarketMoversIndex,
  searchSettings: context => getPremiumMarketMoversSearchSettings(context),
  transformResponse: transformPremiumMarketMoversResponse,
};
